<template>
  <div class='tb-detail'>
    <df-tag :list="labelList" :info="tagInfo" @change="changeTag" class="tag"></df-tag>
    <div class="course-box flex fww" v-if="courseList.length">
      <course-card v-for="(item,i) in courseList" :key="i" :item="item" image-width="226" image-height="259" width="226" imgKey="bgimg" class="course-box-item" is-custom-label showProps="name,hits" @detail="changeJumpEvent(item)" flex='flex-col' show-mask>
      </course-card>
    </div>
    <offline v-else :is-no-data="!courseList.length" show class="no-data"></offline>
    <df-page :total="total" :page-size="limits" :current="curr" @change="changePage"></df-page>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
import Mixins from '@/mixins/mixins';

export default {
  name: 'TbDetail',
  // mixins: [Mixins.MakeRoute(['nianji_id',''], 'query', 'replace')],
  data () {
    return {
      labelList: [
        { label: '年级', prop: 'nianji_id', list: [] },
        { label: '科目', prop: 'xueke_id', list: [] },
        { label: '版本', prop: 'press_id', list: [] },
        {
          label: '排序', prop: 'order_by', list: [
            { name: '默认', id: '' },
            { name: '热门', id: 5 },
            { name: '最新', id: 3 }]
        },
      ],
      tagInfo: {
        nianji_id: '',
        xueke_id: '',
        press_id: '',
        order_by: ''
      },
      curr: 1,
      limits: 20,
      total: 0,
      courseList: [],
    }
  },
  computed: {
    ...mapGetters(['currTab', 'currGrade', 'userInfo']),
  },
  created () {
    Object.assign(this.tagInfo, this.$route.query);
    this.getGrades();
    this.getTagList();
  },
  mounted () { },
  methods: {
    // 获取课程
    getCourseList () {
      let { curr, limits, tagInfo } = this;
      let params = {
        curr,
        limits,
        module_id: 98,
        ...tagInfo,
        is_web: 1,
        uid: this.userInfo.uid,
        is_new: 1,
        ...this.Product
      };
      this.http.getCourseList(params).then(res => {
        this.courseList = res.list;
        this.total = res.total;
      }).catch(this.$err);
    },
    // 点击跳转
    changeJumpEvent (item) {
      this.OpenRouter(`/home/video/details/${item.id}/${item.type}`);
    },
    // 获取年级
    async getGrades () {
      let res = await this.GetGradeList();
      let list =  res.filter(e => e.id !== 18 && e.id !== 19 && e.id !== 20);
      this.labelList.find(e => e.prop === 'nianji_id').list = list.slice(1);
    },
    // 获取学科，出版社
    getTagList () {
      let params = {
        nianji_id: this.tagInfo.nianji_id,
        xueduan_id: this.tagInfo.xueke_id
      };
      this.http.getTag(params).then(res => {
        if (res.subjects && res.subjects.length) {
          let subject = [{ id: 0, name: '全部', press: [] }, ...res.subjects];
          this.labelList.find(e => e.prop === 'xueke_id').list = [];
          this.tagInfo.xueke_id = subject.find(e => +e.id === +this.tagInfo.xueke_id) ? +this.tagInfo.xueke_id : res.subjects[0].id;
          subject.forEach(e => {
            this.labelList.find(e => e.prop === 'xueke_id').list.push({ id: e.id, name: e.name });
            if (this.tagInfo.xueke_id === e.id) {
              let item = +this.tagInfo.xueke_id ? e.press : res.press;
              item.unshift({ id: 0, name: '全部' });
              this.labelList.find(e => e.prop === 'press_id').list = item;
              this.tagInfo.press_id = item.find(j => j.id === this.tagInfo.press_id) ? this.tagInfo.press_id : item[0].id;
            }
          })
        }
        this.getCourseList();
      }).catch(this.$err);
    },
    // 筛选条件
    async changeTag (val, prop) {
      this.tagInfo.xueduan_id && (this.tagInfo.xueduan_id = '');
      this.tagInfo[prop] = val.id;
      await this.getTagList();
    },
    changePage (val, prop) {
      if (this[prop] === val) return;
      this[prop] = val;
      this.getCourseList();
    }
  }
}
</script>

<style scoped lang='less'>
@act-color: #1177ff;
.tag {
  margin-top: 24px;
}
.course-box {
  margin-left: -16px;
  /deep/ .detail-box {
    padding: 0;
    .course-hits {
      padding-top: 16px;
    }
  }
  &-item {
    margin: 0 0 40px 16px;
  }
}
</style>
